export type DedicatedAppPage = 'changes' | 'mcp-authorize' | 'debug' | 'admin' | null

function normalizeLeadingSlash(pathname: string): string {
    return pathname.startsWith('/') ? pathname : `/${pathname}`
}

function normalizeBasePath(basePath: string): string {
    if (!basePath || basePath === '/') return '/'
    return `${normalizeLeadingSlash(basePath).replace(/\/+$/, '')}/`
}

function stripAppBasePath(pathname: string, basePath: string): string {
    const normalizedPath = normalizeLeadingSlash(pathname)
    const normalizedBasePath = normalizeBasePath(basePath)
    if (normalizedBasePath === '/') return normalizedPath

    const baseWithoutTrailingSlash = normalizedBasePath.slice(0, -1)
    if (normalizedPath === baseWithoutTrailingSlash) return '/'
    if (normalizedPath.startsWith(`${baseWithoutTrailingSlash}/`)) {
        return normalizedPath.slice(baseWithoutTrailingSlash.length) || '/'
    }
    return normalizedPath
}

function matchesRouteSegment(pathname: string, route: string): boolean {
    return pathname === route || pathname.startsWith(`${route}/`)
}

export function getDedicatedAppPage(pathname: string, basePath: string): DedicatedAppPage {
    const appRelativePath = stripAppBasePath(pathname, basePath)
    if (matchesRouteSegment(appRelativePath, '/changes')) return 'changes'
    if (matchesRouteSegment(appRelativePath, '/mcp-authorize')) return 'mcp-authorize'
    if (matchesRouteSegment(appRelativePath, '/debug')) return 'debug'
    if (matchesRouteSegment(appRelativePath, '/admin')) return 'admin'
    return null
}
